// extracted by mini-css-extract-plugin
export var coverPlaceholder = "program-modules--coverPlaceholder--3v_fv";
export var exclamationMarkIcon = "program-modules--exclamationMarkIcon--2bZBt";
export var upByStdBorder = "program-modules--upByStdBorder--A-CHg";
export var downloadIcon = "program-modules--downloadIcon--1vxJ6";
export var tab = "program-modules--tab--3neKv";
export var atomicTicketWrapper = "program-modules--atomicTicketWrapper--1FP0O";